/**
 * Vehicle risk analytics payload builder (Milestone 10).
 */
import { trackBuyerEvent } from "./buyerAnalytics";
import { RISK_ANALYTICS_EVENTS } from "../constants/automapAnalyticsEvents";
import { getVehicleRiskViewModel, resolveRiskLevel } from "./vehicleRiskViewModel";

export function buildVehicleRiskAnalyticsPayload(listing, extra = {}) {
  if (!listing) return { ...extra };
  const vm = getVehicleRiskViewModel(listing);
  return {
    listingId: listing.id,
    listingSlug: listing.slug || listing.id,
    dealerId: listing.dealerId || null,
    city: listing.city || null,
    make: listing.make || null,
    model: listing.model || null,
    year: listing.year || null,
    priceCop: listing.priceCop ?? null,
    riskLevel: vm.level || resolveRiskLevel(listing),
    riskFlags: vm.flags || [],
    qualityScore: listing.qualityScore ?? null,
    sourcePage: extra.sourcePage || "vehicle_risk",
    ...extra,
  };
}

export function trackVehicleRiskBuyerEvent(eventType, listing, extra = {}) {
  trackBuyerEvent(eventType, buildVehicleRiskAnalyticsPayload(listing, extra));
}

export function trackVehicleRiskEvent(eventType, metadata = {}) {
  trackBuyerEvent(eventType, { domain: "automap_vehicle_risk", ...metadata });
}

export { RISK_ANALYTICS_EVENTS };
